export const adminNavigation = [
  {
    key: "Zur App",
    label: "Zur App",
    icon: "fa-arrow-left",
    routeName: "Dashboard",
  },
  {
    key: "overview",
    label: "Admin Center",
    icon: "fa-house",
    routeName: "Admincenter",
  },
  {
    key: "operations",
    label: "Aufträge & Planung",
    icon: "fa-list-check",
    items: [
      { key: "jobs", label: "Aufträge", routeName: "Adminjobs", icon: "fa-list" },
      { key: "jobsTable", label: "Aufträge – Tabelle", routeName: "AdminjobsJSS", icon: "fa-table" },
      { key: "planning", label: "Auftragsplanung", routeName: "Adminjobplanning", icon: "fa-file-circle-plus" },
      { key: "planningTable", label: "Auftragsplanung – Tabelle", routeName: "AdminjobplanningJSS", icon: "fa-table" },
      { key: "shiftPlan", label: "Schichtplanung", routeName: "Adminplan", icon: "fa-timeline" },
      { key: "tasks", label: "Aufgaben", routeName: "AdminTasks", icon: "fa-list-check", badge: "tasks" },
    ],
  },
  {
    key: "people",
    label: "Personal",
    icon: "fa-users-rectangle",
    items: [
      { key: "employees", label: "Mitarbeiterverwaltung", routeName: "AdminEmployees", icon: "fa-users-rectangle" },
      { key: "adminUsers", label: "Nutzerverwaltung", routeName: "Adminusers", icon: "fa-users" },
      { key: "meldeliste", label: "Meldeliste", routeName: "AdminMeldeliste", icon: "fa-table" },
    ],
  },
  {
    key: "checkins",
    label: "Check-Ins",
    icon: "fa-clipboard-check",
    routeName: "Admincheckin",
  },
  {
    key: "masterData",
    label: "Datenverwaltung",
    icon: "fa-database",
    items: [
      { key: "contracts", label: "Verträge", routeName: "AdminDataVertraege", icon: "fa-file-contract" },
      { key: "contacts", label: "Kontakte", routeName: "AdminKontakte", icon: "fa-address-book" },
      { key: "rates", label: "Tarife", routeName: "AdminTarife", icon: "fa-euro-sign" },
      { key: "equipment", label: "Equipment", routeName: "AdminDataEquipment", icon: "fa-toolbox" },
      { key: "templates", label: "Vorlagen", routeName: "TemplateDashboard", icon: "fa-file-word" },
      { key: "trainings", label: "Trainings", routeName: "AdminTrainings", icon: "fa-person-chalkboard" },
      { key: "accessCodes", label: "Zugangscodes", routeName: "AdminAccessCodes", icon: "fa-key" },
      { key: "holidays", label: "Feiertage", routeName: "AdminDataHolidays", icon: "fa-calendar-day" },
    ],
  },
  {
    key: "messages",
    label: "Nachrichten",
    icon: "fa-comment",
    routeName: "AdminMessages",
  },
  {
    key: "external",
    label: "Externer Bereich",
    icon: "fa-arrow-up-right-from-square",
    routeName: "ExternalAdmin",
  },
  {
    key: "jobSettings",
    label: "Schichtdokumente & Rundgänge",
    icon: "fa-map-location-dot",
    routeName: "AdminJobSettings",
  },
  {
    key: "reports",
    label: "Auswertungen",
    icon: "fa-chart-line",
    routeName: "Auswertungen",
  },
  {
    key: "billing",
    label: "Abrechnung",
    icon: "fa-file-invoice-dollar",
    items: [
      { key: "payroll", label: "Löhne", routeName: "AdminLohn", icon: "fa-file-invoice-dollar" },
      { key: "timeAccounts", label: "Zeitkonten", routeName: "Zeitkonten", icon: "fa-clock" },
      { key: "invoicing", label: "Auftragsabrechnung", routeName: "AdminInvoicing", icon: "fa-table" },
      { key: "invoiceReview", label: "Rechnungsprüfung", routeName: "AdminRechnungspruefung", icon: "fa-file-circle-check" },
    ],
  },
];
